export const EmailIcon = ({ className, width = '30px', height = '30px' }) => {
  return (
    <svg width={width} height={height} className={className} fill='currentColor' viewBox='0 0 32 32'>
      <path
        d='M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z'
        fill='white'
      />
      <path
        d='M22.0515 8.52295L16.0644 13.1954L9.94043 8.52295V8.52421L9.94783 8.53053V15.0732L15.9954 19.8466L22.0515 15.2575V8.52295Z'
        fill='#EA4335'
      />
      <path
        d='M23.6231 7.38639L22.0508 8.52292V15.2575L26.9983 11.459V9.17074C26.9983 9.17074 26.3978 5.90258 23.6231 7.38639Z'
        fill='#FBBC05'
      />
      <path
        d='M22.0508 15.2575V23.9924H25.8428C25.8428 23.9924 26.9219 23.8813 26.9995 22.6513V11.459L22.0508 15.2575Z'
        fill='#34A853'
      />
      <path d='M9.94811 24.0001V15.0732L9.94043 15.0669L9.94811 24.0001Z' fill='#C5221F' />
      <path
        d='M9.94014 8.52404L8.37646 7.39382C5.60179 5.91001 5 9.17692 5 9.17692V11.4651L9.94014 15.0667V8.52404Z'
        fill='#C5221F'
      />
      <path d='M9.94043 8.52441V15.0671L9.94811 15.0734V8.53073L9.94043 8.52441Z' fill='#C5221F' />
      <path
        d='M5 11.4668V22.6591C5.07646 23.8904 6.15673 24.0003 6.15673 24.0003H9.94877L9.94014 15.0671L5 11.4668Z'
        fill='#4285F4'
      />
    </svg>
  )
}
export const PhoneIcon = ({ className, width = '30px', height = '30px' }) => {
  return (
    <svg width={width} height={height} className={className} fill='currentColor' viewBox='0 0 1024 1024'>
      <path
        d='M85.333333 832V149.333333c0-46.933333 38.4-85.333333 85.333334-85.333333h469.333333c46.933333 0 85.333333 38.4 85.333333 85.333333v682.666667c0 46.933333-38.4 85.333333-85.333333 85.333333H170.666667c-46.933333 0-85.333333-38.4-85.333334-85.333333z'
        fill='#37474F'
      />
      <path
        d='M640 128H170.666667c-12.8 0-21.333333 8.533333-21.333334 21.333333v618.666667c0 12.8 8.533333 21.333333 21.333334 21.333333h469.333333c12.8 0 21.333333-8.533333 21.333333-21.333333V149.333333c0-12.8-8.533333-21.333333-21.333333-21.333333z'
        fill='#BBDEFB'
      />
      <path d='M320 832h128v42.666667h-128z' fill='#78909C' />
      <path
        d='M512 874.666667V362.666667c0-46.933333 38.4-85.333333 85.333333-85.333334h256c46.933333 0 85.333333 38.4 85.333334 85.333334v512c0 46.933333-38.4 85.333333-85.333334 85.333333H597.333333c-46.933333 0-85.333333-38.4-85.333333-85.333333z'
        fill='#E38939'
      />
      <path
        d='M853.333333 341.333333H597.333333c-12.8 0-21.333333 8.533333-21.333333 21.333334v469.333333c0 12.8 8.533333 21.333333 21.333333 21.333333h256c12.8 0 21.333333-8.533333 21.333334-21.333333V362.666667c0-12.8-8.533333-21.333333-21.333334-21.333334z'
        fill='#FFF3E0'
      />
      <path d='M725.333333 906.666667m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z' fill='#A6642A' />
    </svg>
  )
}
export const GithubIcon = ({ className, width = '30px', height = '30px' }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      fill='currentColor'
      viewBox='-1.65 0 259.3 259.3'
      preserveAspectRatio='xMidYMid'
    >
      <g>
        <path
          fill='#9EDCF2'
          d='M200.9,199.8c0,13.9-32.2,25.1-71.9,25.1c-39.7,0-71.9-11.3-71.9-25.1c0-13.9,32.2-25.1,71.9-25.1C168.7,174.7,200.9,185.9,200.9,199.8L200.9,199.8z M200.9,199.8'
        />
        <g>
          <defs>
            <path
              id='SVGID_1_'
              d='M98.1,244.8c1.6,7.5,5.5,11.9,9.4,14.5l41.1,0c5-3.4,10.1-9.8,10.1-21.8v-31c0,0,0.6-7.7,7.7-10.2c0,0,4.1-2.9-0.3-4.5c0,0-19.5-1.6-19.5,14.4v23.6c0,0,0.8,8.7-3.8,12.3v-29.2c0,0,0.3-9.3,5.1-12.8c0,0,3.2-5.7-3.8-4.2c0,0-13.4,1.9-14,17.6l-0.3,30h-3.2l-0.3-30c-0.6-15.6-14-17.6-14-17.6c-7-1.6-3.8,4.2-3.8,4.2c4.8,3.5,5.1,12.8,5.1,12.8v29.5c-4.6-3.3-3.8-12.6-3.8-12.6v-23.6c0-16-19.5-14.4-19.5-14.4c-4.5,1.6-0.3,4.5-0.3,4.5c7,2.6,7.7,10.2,7.7,10.2v21.7L98.1,244.8z'
            />
          </defs>
          <clipPath id='SVGID_2_'>
            <use overflow='visible' />
          </clipPath>
          <path
            clipPath='url(#SVGID_2_)'
            fill='#7DBCE7'
            d='M200.9,199.8c0,13.9-32.2,25.1-71.9,25.1c-39.7,0-71.9-11.3-71.9-25.1c0-13.9,32.2-25.1,71.9-25.1C168.7,174.7,200.9,185.9,200.9,199.8L200.9,199.8z M200.9,199.8'
          />
        </g>
        <path
          fill='#9EDCF2'
          d='M46.9,125.9l-2.1,7.2c0,0-0.5,2.6,1.9,3.1c2.6-0.1,2.4-2.5,2.2-3.2L46.9,125.9L46.9,125.9z M46.9,125.9'
        />
        <path
          fill='#010101'
          d='M255.8,95.6l0.2-0.9c-21.1-4.2-42.7-4.3-55.8-3.7c2.1-7.7,2.8-16.7,2.8-26.6c0-14.3-5.4-25.7-14-34.3c1.5-4.9,3.5-15.8-2-29.7c0,0-9.8-3.1-32.1,11.8c-8.7-2.2-18-3.3-27.3-3.3c-10.2,0-20.5,1.3-30.2,3.9C74.4-2.9,64.3,0.3,64.3,0.3c-6.6,16.5-2.5,28.8-1.3,31.8c-7.8,8.4-12.5,19.1-12.5,32.2c0,9.9,1.1,18.8,3.9,26.5c-13.2-0.5-34-0.3-54.4,3.8l0.2,0.9c20.4-4.1,41.4-4.2,54.5-3.7c0.6,1.6,1.3,3.2,2,4.7c-13,0.4-35.1,2.1-56.3,8.1l0.3,0.9c21.4-6,43.7-7.6,56.6-8c7.8,14.4,23,23.8,50.2,26.7c-3.9,2.6-7.8,7-9.4,14.5c-5.3,2.5-21.9,8.7-31.9-8.5c0,0-5.6-10.2-16.3-11c0,0-10.4-0.2-0.7,6.5c0,0,6.9,3.3,11.7,15.6c0,0,6.3,21,36.4,14.2V177c0,0-0.6,7.7-7.7,10.2c0,0-4.2,2.9,0.3,4.5c0,0,19.5,1.6,19.5-14.4v-23.6c0,0-0.8-9.4,3.8-12.6v38.8c0,0-0.3,9.3-5.1,12.8c0,0-3.2,5.7,3.8,4.2c0,0,13.4-1.9,14-17.6l0.3-39.3h3.2l0.3,39.3c0.6,15.6,14,17.6,14,17.6c7,1.6,3.8-4.2,3.8-4.2c-4.8-3.5-5.1-12.8-5.1-12.8v-38.5c4.6,3.6,3.8,12.3,3.8,12.3v23.6c0,16,19.5,14.4,19.5,14.4c4.5-1.6,0.3-4.5,0.3-4.5c-7-2.6-7.7-10.2-7.7-10.2v-31c0-12.1-5.1-18.5-10.1-21.8c29-2.9,42.9-12.2,49.3-26.8c12.7,0.3,35.6,1.9,57.4,8.1l0.3-0.9c-21.7-6.1-44.4-7.7-57.3-8.1c0.6-1.5,1.1-3,1.6-4.6C212.9,91.4,234.6,91.4,255.8,95.6L255.8,95.6z M255.8,95.6'
        />
        <path
          fill='#F5CCB3'
          d='M174.6,63.7c6.2,5.7,9.9,12.5,9.9,19.8c0,34.4-25.6,35.3-57.2,35.3c-31.6,0-57.2-4.8-57.2-35.3c0-7.3,3.6-14.1,9.8-19.7c10.3-9.4,27.7-4.4,47.4-4.4C147,59.4,164.3,54.3,174.6,63.7L174.6,63.7z M174.6,63.7'
        />
        <path
          fill='#FFFFFF'
          d='M108.3,85.3c0,9.5-5.3,17.1-11.9,17.1c-6.6,0-11.9-7.7-11.9-17.1c0-9.5,5.3-17.1,11.9-17.1C103,68.1,108.3,75.8,108.3,85.3L108.3,85.3z M108.3,85.3'
        />
        <path
          fill='#AF5C51'
          d='M104.5,85.5c0,6.3-3.6,11.4-7.9,11.4c-4.4,0-7.9-5.1-7.9-11.4c0-6.3,3.6-11.4,7.9-11.4C100.9,74.1,104.5,79.2,104.5,85.5L104.5,85.5z M104.5,85.5'
        />
        <path
          fill='#FFFFFF'
          d='M172.2,85.3c0,9.5-5.3,17.1-11.9,17.1c-6.6,0-11.9-7.7-11.9-17.1c0-9.5,5.3-17.1,11.9-17.1C166.8,68.1,172.2,75.8,172.2,85.3L172.2,85.3z M172.2,85.3'
        />
        <path
          fill='#AF5C51'
          d='M168.3,85.5c0,6.3-3.6,11.4-7.9,11.4c-4.4,0-7.9-5.1-7.9-11.4c0-6.3,3.6-11.4,7.9-11.4C164.8,74.1,168.3,79.2,168.3,85.5L168.3,85.5z M168.3,85.5'
        />
        <path
          fill='#AF5C51'
          d='M130.5,100.5c0,1.6-1.3,3-3,3c-1.6,0-3-1.3-3-3s1.3-3,3-3C129.1,97.5,130.5,98.8,130.5,100.5L130.5,100.5z M130.5,100.5'
        />
        <path
          fill='#AF5C51'
          d='M120.6,108c-0.2-0.5,0.1-1,0.6-1.2c0.5-0.2,1,0.1,1.2,0.6c0.8,2.2,2.8,3.6,5.1,3.6c2.3,0,4.3-1.5,5.1-3.6c0.2-0.5,0.7-0.8,1.2-0.6c0.5,0.2,0.8,0.7,0.6,1.2c-1,2.9-3.8,4.9-6.9,4.9C124.4,112.9,121.6,110.9,120.6,108L120.6,108z M120.6,108'
        />
        <path
          fill='#C4E5D9'
          d='M54.5,121.6c0,0.8-0.9,1.4-2.1,1.4c-1.1,0-2.1-0.6-2.1-1.4c0-0.8,0.9-1.4,2.1-1.4C53.6,120.2,54.5,120.8,54.5,121.6L54.5,121.6z M54.5,121.6'
        />
        <path
          fill='#C4E5D9'
          d='M60.3,124.8c0,0.8-0.9,1.4-2.1,1.4c-1.1,0-2.1-0.6-2.1-1.4c0-0.8,0.9-1.4,2.1-1.4C59.4,123.4,60.3,124,60.3,124.8L60.3,124.8z M60.3,124.8'
        />
        <path
          fill='#C4E5D9'
          d='M63.8,129c0,0.8-0.9,1.4-2.1,1.4c-1.1,0-2.1-0.6-2.1-1.4c0-0.8,0.9-1.4,2.1-1.4C62.9,127.5,63.8,128.2,63.8,129L63.8,129z M63.8,129'
        />
        <path
          fill='#C4E5D9'
          d='M67,133.8c0,0.8-0.9,1.4-2.1,1.4c-1.1,0-2.1-0.6-2.1-1.4c0-0.8,0.9-1.4,2.1-1.4C66.1,132.3,67,133,67,133.8L67,133.8z M67,133.8'
        />
        <path
          fill='#C4E5D9'
          d='M70.5,138.2c0,0.8-0.9,1.4-2.1,1.4c-1.1,0-2.1-0.6-2.1-1.4c0-0.8,0.9-1.4,2.1-1.4C69.6,136.8,70.5,137.4,70.5,138.2L70.5,138.2z M70.5,138.2'
        />
        <path
          fill='#C4E5D9'
          d='M75.3,142.1c0,0.8-0.9,1.4-2.1,1.4c-1.1,0-2.1-0.6-2.1-1.4c0-0.8,0.9-1.4,2.1-1.4C74.4,140.6,75.3,141.3,75.3,142.1L75.3,142.1z M75.3,142.1'
        />
        <path
          fill='#C4E5D9'
          d='M82,144.6c0,0.8-0.9,1.4-2.1,1.4c-1.1,0-2.1-0.6-2.1-1.4c0-0.8,0.9-1.4,2.1-1.4C81.1,143.2,82,143.8,82,144.6L82,144.6z M82,144.6'
        />
        <path
          fill='#C4E5D9'
          d='M88.7,144.6c0,0.8-0.9,1.4-2.1,1.4c-1.1,0-2.1-0.6-2.1-1.4c0-0.8,0.9-1.4,2.1-1.4C87.8,143.2,88.7,143.8,88.7,144.6L88.7,144.6z M88.7,144.6'
        />
        <path
          fill='#C4E5D9'
          d='M95.5,143.5c0,0.8-0.9,1.4-2.1,1.4c-1.1,0-2.1-0.6-2.1-1.4c0-0.8,0.9-1.4,2.1-1.4C94.5,142.1,95.5,142.7,95.5,143.5L95.5,143.5z M95.5,143.5'
        />
      </g>
    </svg>
  )
}
export const TagLinkIcon = ({ className, width = '30px', height = '30px' }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      fill='currentColor'
      viewBox='0 0 128 128'
      aria-hidden='true'
      role='img'
    >
      <path
        d='M23.91 104.02c-6.5-6.63-6.5-17.21 0-23.84l18.74-18.74c2.04-2.04 4.72-3.57 7.52-4.33c2.8-.76 5.74-.76 8.41-.13c2.8.76 5.48 2.17 7.65 4.21l.25.25c6.63 6.63 6.63 17.21 0 23.84l-18.74 18.74c-6.62 6.63-17.33 6.63-23.83 0zm53.03-53.03c-12.36-12.36-32.63-12.36-45 0L13.33 69.73c-12.36 12.36-12.36 32.63 0 45s32.63 12.36 45 0l18.74-18.74c12.23-12.37 12.23-32.63-.13-45z'
        fill='#84b0c1'
      ></path>
      <path
        d='M66.86 48.48c3.36-1.69 6.57-.51 6.57-.51c-6.94-5.13-14.51-6.59-21.03-6.18c-.04.05-.07.1-.11.16c-2.86 4.39-3.5 10.19-1.72 15.07c2.68-.66 5.46-.64 8-.03c1.04.28 1.83.55 3.39 1.28c.01-.01-.54-7.05 4.9-9.79z'
        fill='#2f7889'
      ></path>
      <path
        d='M46.76 58.46c.13-.97.19-1.95.25-2.93c.28-4.22 1-8.42 2.14-12.49c.08-.29.16-.6.24-.91c-3.09.49-6.12 1.43-8.97 2.83c-4.44 5.73-2.98 13.15 2.23 16.49c1.19-1.19 2.59-2.2 4.11-2.99z'
        fill='#2f7889'
      ></path>
      <path
        d='M104.09 23.98c6.5 6.63 6.5 17.21 0 23.84L85.35 66.56c-2.04 2.04-4.72 3.57-7.52 4.33s-5.74.76-8.41.13c-2.8-.76-5.48-2.17-7.65-4.21l-.25-.25c-6.63-6.63-6.63-17.21 0-23.84l18.74-18.74c6.62-6.63 17.33-6.63 23.83 0zM51.06 77.01c12.36 12.36 32.63 12.36 45 0l18.61-18.74c12.36-12.36 12.36-32.63 0-45s-32.63-12.36-45 0L50.94 32.01c-12.24 12.37-12.24 32.63.12 45z'
        fill='#84b0c1'
      ></path>
      <path
        d='M50.45 39.42c.04-.03.08-.07.12-.1c.53-.46 1.12-.9 1.81-1.02s1.5.19 1.74.85c.18.49.02 1.03-.15 1.52c-2.63 7.95-4.74 18.04-2.18 26.27c.25.8.49 1.83-.18 2.33c-.39.3-.97.25-1.4.02c-4.7-2.54-5.52-9.42-5.74-14.14c-.26-5.96 1.39-11.7 5.98-15.73z'
        fill='#a8e3f0'
      ></path>
      <path
        d='M71.32 71.34c-.64-.08-1.32-.21-1.32-.21s-.1 4.27-3.51 7.81c-3.78 3.92-7.55 3.82-7.55 3.82c1.99 1.15 5.96 2.34 7.4 2.68l.15-.15c3.83-3.84 5.43-9 4.83-13.95z'
        fill='#2f7889'
      ></path>
      <path
        d='M90.76 61.15l-5.33 5.33c1.33 5.94.97 12.18-1.09 17.94c2.59-.92 5.08-2.19 7.4-3.8c3.83-6.56 2.99-14.31-.98-19.47z'
        fill='#2f7889'
      ></path>
      <path
        d='M79.89 70.01c-.63-1.59-1.86-3.2-3.4-3.05c-.96.09-2.45.99-2.35 3.74c.07 2.13.88 4.21-.28 7c-1.7 4.08-1.31 5.18-.9 5.83c.45.71 1.28 1.03 2.05 1.02c2.03-.01 3.71-1.87 4.63-3.91c1.49-3.26 1.58-7.29.25-10.63z'
        fill='#a8e3f0'
      ></path>
      <path
        d='M49.25 108.18c.64-.53 2.3-2.3 3.07-1.18c-.28 3.08-2.65 5.59-5.25 7.27c-3.2 2.07-6.99 3.29-10.8 3.18c-3.16-.09-8.4-1.37-10.24-4.3c-1.5-2.38 1.67-2.79 3.43-2.13c6.27 2.39 13.36 2.44 19.79-2.84z'
        fill='#a8e3f0'
      ></path>
    </svg>
  )
}
